// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"ee7accd9","498":"c2b9fa2f","598":"e8ea6458","787":"7e48db0c"}[chunkId] + ".chunk.js";
};